import React, {Component} from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';

class HeatMapRowLabels extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    const sizeDifferent = nextProps.cellSize !== this.props.cellSize;
    const dataDifferent = nextProps.data !== this.props.data;
    const dimDiff = nextProps.dimId !== this.props.dimId;
    const selectedDiff = nextProps.selectedId !== this.props.selectedId;
    const hoverDiff = nextProps.hoverIndex !== this.props.hoverIndex;

    return sizeDifferent || dataDifferent || selectedDiff || dimDiff || hoverDiff;
  }

  getClassName(d, i) {
    let cl = "rowLabel mono r" + i;
    if (this.props.selectedId === d[this.props.dimId]) {
      cl += ' selected-row';
    }
    if (this.props.hoverIndex === i) {
      cl += ' highlight';
    }
    return cl
  }

  getText(d, i) {
    return _.truncate(d[this.props.dimLabel], {length: 20})
  }

  render() {
    const data = this.props.data || [];
    const width = this.props.width;
    const cellSize = this.props.cellSize;

    const getHandlers = (d, i) => {
      const onClick = this.props.onClick;
      const onHover = this.props.onHover;
      const handlers = {};

      if (onClick) {
        handlers.onClick = () => onClick(d, i);
      }

      if (onHover) {
        handlers.onMouseEnter = () => onHover(i);
        handlers.onMouseLeave = () => onHover(-1);
      }

      return handlers;
    };

    return (
      <g>
        {_.map(data, (d, i) => {
          return (
            <g key={i}
               className="rowLabelGroup"
               height={cellSize}
               width={width}
               transform={`translate(${-1 * width},${i * cellSize})`}
               {...getHandlers(d, i)}>
              <rect
                className="background"
                height={cellSize}
                width={width}
              ></rect>
              <text
                x={width - 8}
                y={cellSize / 2}
                alignmentBaseline="middle"
                style={{textAnchor: 'end'}}
                className={this.getClassName(d, i)}>
                {this.getText(d)}
              </text>
            </g>
          )
        })}
      </g>
    )
  }
}

HeatMapRowLabels.propTypes = {
  width: PropTypes.number,
  cellSize: PropTypes.number,
  onClick: PropTypes.func,
  onHover: PropTypes.func,
  data: PropTypes.array,
  dimId: PropTypes.string,
  selectedId: PropTypes.number,
  hoverIndex: PropTypes.number,
  dimLabel: PropTypes.string
};

export default HeatMapRowLabels


// WEBPACK FOOTER //
// ./src/charts/HeatMap/HeatMapRowLabels.js